import { createContext } from "react";
import { ProfileSubUsersENTContextProps } from "./ProfileSubUsersENT.types";

export const ProfileSubUsersENTContext = createContext<ProfileSubUsersENTContextProps>({} as ProfileSubUsersENTContextProps)